export function getFileNameFromContentDispositionHeader (response) {
  return (
    response.headers['content-disposition']
      .split(';')
      .find((n) => n.includes('filename='))
      .replace('filename=', '')
      .trim()
  )
}
